export const config = {
    LanguagesFor1SymbolSearch: "",
    LanguagesFor2SymbolSearch: "",
    IsRecommendedEventsEnabled: false,
    IsRecentResultsEnabled: false,
    MaxRecentsCount: 3
};
//# sourceMappingURL=config.js.map